<template>
  <div>
    <table class="table table-dark">
      <thead>
      <tr>
        <th>Username</th>
        <th>Name</th>
        <th>Email</th>
        <th>Permission</th>
        <th>Last Login</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="user in users" :key="user.id">
        <td>
          <i class="fas fa-user green" v-if="user.active" v-tooltip="'Active'"></i>
          <i class="fas fa-user-slash red" v-else v-tooltip="'Blocked'"></i>
          <router-link :to="'/account/user/' + user.id">{{ user.username }}</router-link>
        </td>
        <td>{{ user.name }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.groups.map(g => g.name).join(',') || 'All Groups' }}</td>
        <td>{{ user.lastLogin | aTime('from') }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from 'axios'
import { eventBus } from '../../../../main'

export default {
  data () {
    return {
      users: []
    }
  },
  mounted () {
    this.getUsers()
    eventBus.$on('reloadUsers', () => {
      this.getUsers()
    })
  },
  methods: {
    getUsers () {
      axios.get('/client/users')
        .then(r => {
          this.users = r.data.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/ClientAccount/Users/List.vue